import { useState } from 'react';

const useBarGraphTile = () => {
  const [isBarGraphDrawerOpen, setIsBarGraphDrawerOpen] = useState(false);

  const handleCloseBarGraphDrawer = () => {
    setIsBarGraphDrawerOpen(false);
  };

  const handleClick = () => {
    setIsBarGraphDrawerOpen(true);
  };

  return { isBarGraphDrawerOpen, handleCloseBarGraphDrawer, handleClick };
};

export default useBarGraphTile;
